import Boom from 'boom'
import makeApi from '../client/api'

export const creditCardRecord = async (creditcard, token) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const { ok, data } = await api.post('/creditcards', {
    user_id: creditcard.user_id,
    holderName: creditcard.holderName,
    number: creditcard.number,
    expiryMonth: creditcard.expiryMonth,
    expiryYear: creditcard.expiryYear,
    ccv: creditcard.ccv,
    email: creditcard.email,
    cpf: creditcard.cpf,
    postalCode: creditcard.postalCode,
    addressNumber: creditcard.addressNumber,
    phone: creditcard.phone,
  })

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}

export const getUserCreditcards = async (userId, token) => {
  const { api } = makeApi({ token })

  const { ok, data } = await api.get(`/creditcards?user_id=${userId}`)

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}

export const deleteCreditCardById = async (creditCardId, token) => {
  const { api } = makeApi({ token })

  const { ok, data } = await api.delete('/creditcards', { id: creditCardId })

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}
